import React, { useState } from 'react';
import { Modal, Input, Button, Form } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faLock, faUser, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { loginUserClient } from '../../configurations/features/authSliceUser';
import { toastClick } from '../../composants/toast/CustomToast';

const ReLoginModal = () => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            dispatch(loginUserClient(values.login.trim(), values.password.trim(), setLoading));
        } catch (e) {
            // Erreurs de validation du formulaire → Ant Design les affiche automatiquement
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    return (
        <Modal
            open={true}
            closable={false}
            maskClosable={false}
            keyboard={false}
            footer={null}
            centered
            width={440}
            styles={{
                mask: {
                    backdropFilter: 'blur(4px)',
                    backgroundColor: 'rgba(0, 0, 0, 0.65)',
                },
            }}
        >
            {/* En-tête */}
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
                <div
                    style={{
                        width: 64,
                        height: 64,
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 16px',
                        boxShadow: '0 8px 24px rgba(102, 126, 234, 0.4)',
                    }}
                >
                    <FontAwesomeIcon icon={faShieldAlt} style={{ fontSize: 28, color: '#fff' }} />
                </div>

                <h2
                    style={{
                        margin: 0,
                        fontSize: 20,
                        fontWeight: 700,
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                    }}
                >
                    Session expirée
                </h2>
                <p style={{ margin: '8px 0 0', color: '#888', fontSize: 13 }}>
                    Pour des raisons de sécurité, veuillez vous reconnecter pour continuer.
                </p>
            </div>

            {/* Formulaire */}
            <Form form={form} layout="vertical" onKeyDown={handleKeyDown}>
                <Form.Item
                    name="login"
                    label={<span style={{ fontWeight: 600, color: '#444' }}>Identifiant</span>}
                    rules={[{ required: true, message: 'Veuillez saisir votre identifiant' }]}
                >
                    <Input
                        prefix={
                            <FontAwesomeIcon
                                icon={faUser}
                                style={{ color: '#667eea', marginRight: 6 }}
                            />
                        }
                        size="large"
                        placeholder="Votre identifiant"
                        style={{ borderRadius: 8 }}
                        autoFocus
                    />
                </Form.Item>

                <Form.Item
                    name="password"
                    label={<span style={{ fontWeight: 600, color: '#444' }}>Mot de passe</span>}
                    rules={[{ required: true, message: 'Veuillez saisir votre mot de passe' }]}
                >
                    <Input
                        prefix={
                            <FontAwesomeIcon
                                icon={faLock}
                                style={{ color: '#667eea', marginRight: 6 }}
                            />
                        }
                        suffix={
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{ cursor: 'pointer', color: '#aaa' }}
                            >
                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                            </span>
                        }
                        type={showPassword ? 'text' : 'password'}
                        size="large"
                        placeholder="Votre mot de passe"
                        style={{ borderRadius: 8 }}
                    />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
                    <Button
                        type="primary"
                        size="large"
                        block
                        loading={loading}
                        onClick={handleSubmit}
                        style={{
                            height: 48,
                            borderRadius: 8,
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            border: 'none',
                            fontSize: 15,
                            fontWeight: 600,
                            boxShadow: '0 4px 16px rgba(102, 126, 234, 0.4)',
                            transition: 'all 0.3s',
                        }}
                    >
                        Se reconnecter
                    </Button>
                </Form.Item>
            </Form>

            {/* Avertissement */}
            <div
                style={{
                    marginTop: 20,
                    padding: '10px 16px',
                    background: 'rgba(102, 126, 234, 0.06)',
                    borderRadius: 8,
                    border: '1px solid rgba(102, 126, 234, 0.15)',
                    textAlign: 'center',
                }}
            >
                <span style={{ fontSize: 12, color: '#999' }}>
                    🔒 Cette fenêtre ne peut pas être fermée. La reconnexion est obligatoire.
                </span>
            </div>
        </Modal>
    );
};

export default ReLoginModal;
